import React from 'react';
import PropTypes from 'prop-types';
import { Rate } from 'antd';
import { LocalizationContext } from '../../../../hoc/Localization';
import styles from '../../TopBar/styles.less';

const RatingFilter = ({ rating, setRating }) => {
  const { t } = React.useContext(LocalizationContext);

  return (
    <>
      <p className={styles.note}>{t('search.filters.rating.order')}</p>

      <div className={styles.ratingStars}>
        <Rate defaultValue={rating} onChange={setRating} />
      </div>
    </>
  );
};

RatingFilter.propTypes = {
  rating: PropTypes.number,
  setRating: PropTypes.func,
};

RatingFilter.defaultProps = {
  rating: 0,
  setRating: () => null,
};

export default RatingFilter;
